import { withInstall } from '@ll-plus/utils'

import Rate from './src/rate.vue'

export const LlRate = withInstall(Rate)

export * from './src/rate'

declare module 'vue' {
  export interface GlobalComponents {
    LlRate: typeof Rate
  }
}
